import experimentFlagsHelper from '@zola-helpers/client/dist/es/util/experimentFlagsHelper';
import experimentsFlagsHelperSSR from '@zola-helpers/server/dist/es/experiments';

// Experiment Keys
// export const EXAMPLE_FLAG = 'example-flag'; // https://newamsterdamlabs.atlassian.net/browse/CE-1147
export const PAPER_ADD_ONS = 'paper-add-ons';
export const CORE_CONTACT_COLLECTOR_REDESIGN = 'core-contact-collector-redesign';
export const WW_LP_REDESIGN = 'ww-lp-redesign';
export const PAPER_OPTIMIZATION_SECONDARY_NAV = 'paper-optimization-secondary-nav';

// Seasonal flags
export const HOLIDAY_CARDS = 'holiday-cards';
export const HOLIDAY_SHOPS = 'holiday-shops';

const FALLBACK_VARIATIONS = {
  // [EXAMPLE_FLAG]: experimentFlagsHelper.createExperimentFlags(),
  [PAPER_ADD_ONS]: experimentFlagsHelper.createExperimentFlags(),
  [CORE_CONTACT_COLLECTOR_REDESIGN]: experimentFlagsHelper.createExperimentFlags(),
  [WW_LP_REDESIGN]: experimentFlagsHelper.createExperimentFlags(),
  [PAPER_OPTIMIZATION_SECONDARY_NAV]: experimentFlagsHelper.createExperimentFlags(),
  [HOLIDAY_CARDS]: experimentFlagsHelper.createExperimentFlags(),
  [HOLIDAY_SHOPS]: experimentFlagsHelper.createExperimentFlags(),
};

export default experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);

const FALLBACK_VARIATIONS_SSR = {
  // [EXAMPLE_FLAG]: experimentFlagsHelper.createExperimentFlags(),
  [CORE_CONTACT_COLLECTOR_REDESIGN]: experimentFlagsHelper.createExperimentFlags(),
};

export const experimentFlagsSSR =
  experimentsFlagsHelperSSR.makeExperimentFlags(FALLBACK_VARIATIONS_SSR);
